import { render, staticRenderFns } from "./Agency.vue?vue&type=template&id=2d95180a&scoped=true&"
import script from "./Agency.vue?vue&type=script&lang=js&"
export * from "./Agency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95180a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/azureuser/wnytoys/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d95180a')) {
      api.createRecord('2d95180a', component.options)
    } else {
      api.reload('2d95180a', component.options)
    }
    module.hot.accept("./Agency.vue?vue&type=template&id=2d95180a&scoped=true&", function () {
      api.rerender('2d95180a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/app/components/agency/Agency.vue"
export default component.exports